var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['progress__bloks flex__bc', 'progress__' + _vm.params.state]},_vm._l((_vm.blocks),function(n,index){return _c('div',{key:index})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }